// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessBodyAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var compose = require('recompose').compose;
  var lifecycle = require('recompose').lifecycle;
  var setPropTypes = require('recompose').setPropTypes;
  var React = require('react');

  var accessBodyAction = compose(
    setPropTypes({
      store: React.PropTypes.object.isRequired
    }),
    lifecycle({
      /**
       * Load all access when go to access page
       */
      componentDidMount: function () {
        var props = this.props;
        var store = props.store;
        var accessStore = store.accessStore;
        var reportModel = store.model;
        var loader = props.loader;
        loader.startLoading();
        accessStore.initialAccessReportPage(
          reportModel.reportId, 
          reportModel.reportAccess.
          draftAccesses, reportModel.isGlobal)
        .finally(loader.endLoading.bind(loader));
      },

      /**
       * Load all access after save
       */
      componentWillReceiveProps: function (nextProps) {
        var store = nextProps.store;
        var accessStore = store.accessStore;
        var reportModel = store.model;
        var loader = nextProps.loader;
        loader.startLoading();
        accessStore.loadAllAccess(reportModel.reportId, reportModel.accesses,  reportModel.isGlobal)
        .finally(loader.endLoading.bind(loader));
      },
    })
  );

  module.exports = accessBodyAction;
}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Access/Izenda.AccessBodyAction.js